/* ==========================================================================
   Haraka x Haglöfs-struktur: beteenden
   - ha-header: kortet som växer ur pillret, megameny med undernivåer, sök,
     önskelista, konto, mobilmeny, scrolläge
   - topprad: rotation med paus, platsruta
   - karuseller, bildbläddring på produktkort, bildbyte vid hover
   - önskelista i localStorage, senaste sökningar, medlemsruta, "Visa fler"
   ========================================================================== */
(function () {
  'use strict';

  var store = {
    get: function (key, fallback) {
      try {
        var v = window.localStorage.getItem(key);
        return v ? JSON.parse(v) : fallback;
      } catch (e) {
        return fallback;
      }
    },
    set: function (key, value) {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    }
  };

  function lock(on) {
    document.documentElement.classList.toggle('ha-lock', on);
  }

  /* ---------------------------------------------------------------------- */
  /* Sidhuvudet                                                             */
  /* ---------------------------------------------------------------------- */
  class HaHeader extends HTMLElement {
    connectedCallback() {
      this.shell = this.querySelector('[data-ha-shell]');
      this.overlay = this.querySelector('[data-ha-overlay]');
      this.panels = Array.from(this.querySelectorAll('.ha-panel'));
      this.current = null;
      this.fromMobile = false;

      this.addEventListener('click', this.onClick.bind(this));
      this.overlay.addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.current) this.close();
      });
      document.addEventListener('click', (e) => {
        var opener = e.target.closest('[data-ha-open]');
        if (opener && !this.contains(opener)) {
          e.preventDefault();
          this.open(opener.getAttribute('data-ha-open'));
        }
      });

      var onScroll = () => {
        this.classList.toggle('is-scrolled', window.scrollY > 24);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      if (this.dataset.overlay !== 'true' && document.body.classList.contains('ha-t-index')) document.body.classList.add('ha-no-overlay');

      this.querySelectorAll('.ha-mega').forEach((m) => this.resetMega(m));
    }

    onClick(e) {
      var t = e.target;
      var opener = t.closest('[data-ha-open]');
      if (opener) {
        e.preventDefault();
        var id = opener.getAttribute('data-ha-open');
        this.fromMobile = opener.hasAttribute('data-ha-from-mobile');
        if (this.current === id && !this.fromMobile) this.close();
        else this.open(id);
        return;
      }
      if (t.closest('[data-ha-close]')) {
        this.close();
        return;
      }
      var sub = t.closest('[data-ha-sub]');
      if (sub) {
        this.goSub(sub);
        return;
      }
      if (t.closest('[data-ha-back]')) {
        this.goBack(t.closest('.ha-mega'), t.closest('.ha-mega__view'));
        return;
      }
      if (t.closest('[data-ha-mobile-home]')) {
        this.open('mobile');
        return;
      }
      var tab = t.closest('[data-ha-tab]');
      if (tab) {
        var name = tab.getAttribute('data-ha-tab');
        this.querySelectorAll('[data-ha-tab]').forEach((b) => {
          var on = b === tab;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.querySelectorAll('[data-ha-tabpane]').forEach((p) => {
          p.hidden = p.getAttribute('data-ha-tabpane') !== name;
        });
      }
    }

    isMobile() {
      return window.matchMedia('(max-width: 1174px)').matches;
    }

    open(id) {
      if (id === 'cart') return;
      var panel = this.querySelector('[data-panel="' + id + '"]');
      if (!panel) return;
      this.panels.forEach((p) => (p.hidden = p !== panel));
      this.querySelectorAll('[data-ha-open]').forEach((b) => {
        if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', b.getAttribute('data-ha-open') === id ? 'true' : 'false');
      });
      if (panel.classList.contains('ha-mega')) this.resetMega(panel);
      this.shell.classList.add('is-open');
      this.overlay.classList.add('is-open');
      this.current = id;
      if (this.isMobile()) lock(true);
      if (id === 'search') {
        var input = panel.querySelector('input[type="search"]');
        setTimeout(function () { input && input.focus(); }, 60);
        renderRecent();
      }
      if (id === 'wishlist') renderWishlist();
      if (id === 'account') vackSkrappostskydd(panel);
    }

    close() {
      this.panels.forEach((p) => (p.hidden = true));
      this.shell.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.querySelectorAll('[aria-expanded]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      this.current = null;
      lock(false);
    }

    /* Vyer i megamenyn: vänster och höger plats. En undernivå öppnas till
       höger; öppnas en undernivå från högerplatsen glider båda ett steg. */
    resetMega(mega) {
      mega.querySelectorAll('.ha-mega__view').forEach((v) => {
        v.removeAttribute('data-slot');
        v.hidden = true;
      });
      this.place(mega, 'root', 'left');
      this.place(mega, 'promo', 'right');
      mega.querySelectorAll('.is-current').forEach((i) => i.classList.remove('is-current'));
    }

    view(mega, id) {
      return mega.querySelector('[data-view="' + id + '"]');
    }

    place(mega, id, slot) {
      var v = this.view(mega, id);
      if (!v) return;
      mega.querySelectorAll('[data-slot="' + slot + '"]').forEach((o) => {
        o.removeAttribute('data-slot');
        o.hidden = true;
      });
      v.hidden = false;
      v.setAttribute('data-slot', slot);
      v.style.animation = 'none';
      void v.offsetWidth;
      v.style.animation = '';
    }

    goSub(btn) {
      var mega = btn.closest('.ha-mega');
      var fromView = btn.closest('.ha-mega__view');
      var target = btn.getAttribute('data-ha-sub');
      fromView.querySelectorAll('.is-current').forEach((i) => i.classList.remove('is-current'));
      btn.classList.add('is-current');
      if (this.isMobile()) {
        this.place(mega, target, 'left');
        mega.scrollTop = 0;
        return;
      }
      if (fromView.getAttribute('data-slot') === 'right') {
        this.place(mega, fromView.getAttribute('data-view'), 'left');
      }
      this.place(mega, target, 'right');
    }

    goBack(mega, fromView) {
      var parent = fromView.getAttribute('data-parent') || 'root';
      if (this.isMobile()) {
        this.place(mega, parent, 'left');
        return;
      }
      /* Ett steg tillbaka: föräldern till vänster, vyn man lämnade till höger */
      this.place(mega, parent, 'left');
      this.place(mega, fromView.getAttribute('data-view'), 'right');
    }
  }
  if (!customElements.get('ha-header')) customElements.define('ha-header', HaHeader);

  /* ---------------------------------------------------------------------- */
  /* Topprad                                                                */
  /* ---------------------------------------------------------------------- */
  function initTopbar() {
    document.querySelectorAll('[data-ha-topbar]').forEach(function (bar) {
      var msgs = Array.from(bar.querySelectorAll('.ha-topbar__msg'));
      if (msgs.length < 2) return;
      var i = 0;
      var speed = parseInt(bar.dataset.speed, 10) || 5000;
      var timer = null;
      function next() {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }
      function play() { timer = setInterval(next, speed); }
      function stop() { clearInterval(timer); timer = null; }
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
      var toggle = bar.querySelector('[data-ha-topbar-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var paused = bar.classList.toggle('is-paused');
          toggle.setAttribute('aria-label', paused ? 'Spela budskapen' : 'Pausa budskapen');
          if (paused) stop(); else play();
        });
      }
    });

    var modal = document.querySelector('[data-ha-locmodal]');
    if (modal) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-ha-loc-open]')) { modal.hidden = false; lock(true); }
        if (e.target.closest('[data-ha-loc-close]') || e.target === modal) { modal.hidden = true; lock(false); }
      });
    }
  }

  /* ---------------------------------------------------------------------- */
  /* Karuseller                                                             */
  /* ---------------------------------------------------------------------- */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-ha-carousel]').forEach(function (c) {
      if (c.dataset.haReady) return;
      c.dataset.haReady = '1';
      var track = c.querySelector('[data-ha-track]');
      var prev = c.querySelector('[data-ha-prev]');
      var next = c.querySelector('[data-ha-next]');
      if (!track) return;
      function step() {
        var first = track.children[0];
        return first ? first.getBoundingClientRect().width + 2 : track.clientWidth * 0.8;
      }
      function update() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Bildbläddring på produktkort                                           */
  /*                                                                        */
  /* Bilderna ligger i ett svepbart spår. Svepet sköter webbläsaren själv    */
  /* med scroll-snap; här håller vi bara förloppsraden i takt och låter      */
  /* pilarna rulla ett steg. Mönstret är haglofs.com:s.                      */
  /* ---------------------------------------------------------------------- */
  function kortbild(spar) {
    var kort = spar.closest('[data-ha-card]');
    var segs = kort ? kort.querySelectorAll('.ha-card__seg') : [];
    if (!segs.length) return;
    var i = Math.round(spar.scrollLeft / spar.clientWidth);
    if (i < 0) i = 0;
    if (i > segs.length - 1) i = segs.length - 1;
    segs.forEach(function (seg, n) { seg.classList.toggle('is-active', n === i); });
    // Ladda grannbilden i förväg, så nästa svep inte möts av en tom ruta
    var bilder = spar.querySelectorAll('.ha-card__slide');
    var nasta = bilder[i + 1];
    if (nasta && nasta.loading === 'lazy') nasta.loading = 'eager';
  }

  /* Svepet styrs av oss, inte av webblasaren.
     Skalet: kortet ligger inuti produktradens egen vagrata karusell, och tva
     nativa vagrata rullningar pa samma plats gar inte att skilja at. Raden
     vann alltid. Nu fangar vi rorelsen sjalva och stoppar den fran att na
     raden, men BARA nar dragningen ar tydligt vagrat. Ar den lodrat slapper
     vi igenom, sa sidan gar att rulla med fingret pa en bild, och ar den
     vagrat pa texten under bilden far raden gesten som vanligt. */
  function initKortbilder(scope) {
    (scope || document).querySelectorAll('[data-ha-spar]').forEach(function (spar) {
      if (spar.dataset.haSparBunden === '1') return;
      spar.dataset.haSparBunden = '1';

      var startX = 0, startY = 0, startScroll = 0, riktning = '', drar = false;

      spar.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startScroll = spar.scrollLeft;
        riktning = '';
        drar = true;
      }, { passive: true });

      spar.addEventListener('touchmove', function (e) {
        if (!drar) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (!riktning) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          riktning = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (riktning !== 'x') return;
        e.preventDefault();            // hindrar raden fran att ta over
        spar.scrollLeft = startScroll - dx;
        kortbild(spar);
      }, { passive: false });

      function slapp(e) {
        if (!drar) return;
        drar = false;
        if (riktning !== 'x') return;
        var slutX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : startX;
        var dx = slutX - startX;
        var bredd = spar.clientWidth || 1;
        var antal = spar.querySelectorAll('.ha-card__slide').length;
        var i = Math.round(startScroll / bredd);
        if (Math.abs(dx) > bredd * 0.18) i += dx < 0 ? 1 : -1;
        i = Math.max(0, Math.min(antal - 1, i));
        spar.scrollTo({ left: i * bredd, behavior: 'smooth' });
        setTimeout(function () { kortbild(spar); }, 260);
      }
      spar.addEventListener('touchend', slapp, { passive: true });
      spar.addEventListener('touchcancel', slapp, { passive: true });

      spar.addEventListener('scroll', function () { kortbild(spar); }, { passive: true });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ha-flip]');
    if (!btn) return;
    e.preventDefault();
    var kort = btn.closest('[data-ha-card]');
    var spar = kort && kort.querySelector('[data-ha-spar]');
    if (!spar) return;
    var steg = parseInt(btn.getAttribute('data-ha-flip'), 10);
    var antal = spar.querySelectorAll('.ha-card__slide').length;
    var i = Math.round(spar.scrollLeft / spar.clientWidth) + steg;
    if (i < 0) i = antal - 1;
    if (i > antal - 1) i = 0;
    spar.scrollTo({ left: i * spar.clientWidth, behavior: 'smooth' });
  });

  /* ---------------------------------------------------------------------- */
  /* Bildbyte vid hover (kroppsdelslistan på startsidan)                    */
  /* ---------------------------------------------------------------------- */
  function initHoverSwap() {
    document.querySelectorAll('[data-ha-swap]').forEach(function (block) {
      var links = block.querySelectorAll('[data-ha-swap-to]');
      var imgs = block.querySelectorAll('[data-ha-swap-img]');
      function show(idx) {
        imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-ha-swap-img') === idx); });
        links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-ha-swap-to') === idx); });
      }
      links.forEach(function (l) {
        l.addEventListener('mouseenter', function () { show(l.getAttribute('data-ha-swap-to')); });
        l.addEventListener('focus', function () { show(l.getAttribute('data-ha-swap-to')); });
      });
      // Väljaren i två steg: kroppsdelen fäller ut besvären, en i taget
      var toggles = block.querySelectorAll('[data-ha-swap-toggle]');
      toggles.forEach(function (btn) {
        // Bind bara en gång, även om initieringen körs flera gånger
        if (btn.dataset.haBound) return;
        btn.dataset.haBound = '1';
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          toggles.forEach(function (other) {
            other.setAttribute('aria-expanded', 'false');
            var os = document.getElementById(other.getAttribute('aria-controls'));
            if (os) os.hidden = true;
            if (other.parentElement) other.parentElement.classList.remove('is-open');
          });
          if (!open) {
            btn.setAttribute('aria-expanded', 'true');
            var sub = document.getElementById(btn.getAttribute('aria-controls'));
            if (sub) sub.hidden = false;
            if (btn.parentElement) btn.parentElement.classList.add('is-open');
            show(btn.getAttribute('data-ha-swap-to'));
          }
        });
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Önskelista (sparas i webbläsaren)                                      */
  /* ---------------------------------------------------------------------- */
  var WKEY = 'haraka-wishlist';
  function wishlist() { return store.get(WKEY, []); }
  function syncWish() {
    var list = wishlist();
    document.querySelectorAll('[data-ha-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-ha-wish')) !== -1;
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-ha-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ha-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-ha-wish');
    var list = wishlist();
    var i = list.indexOf(h);
    if (i === -1) list.unshift(h); else list.splice(i, 1);
    store.set(WKEY, list.slice(0, 60));
    syncWish();
    if (b.closest('.ha-wishpanel')) renderWishlist();
  });
  function money(cents) {
    try {
      return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK', maximumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100);
    } catch (e) {
      return (cents / 100) + ' kr';
    }
  }
  function renderWishlist() {
    var wrap = document.querySelector('[data-ha-wish-list]');
    if (!wrap) return;
    var list = wishlist();
    var tomtext = document.querySelector('[data-ha-wish-empty]');
    if (tomtext) tomtext.hidden = list.length > 0;
    wrap.innerHTML = '';
    list.forEach(function (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var el = document.createElement('div');
          el.className = 'ha-wishitem';
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
          el.innerHTML =
            '<button type="button" class="ha-wishitem__remove" data-ha-wish="' + p.handle + '" aria-label="Ta bort ur önskelistan">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
            '<a class="ha-mini" href="' + p.url + '"><span class="ha-mini__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="ha-mini__title"></span><span class="ha-price"></span></a>';
          el.querySelector('.ha-mini__title').textContent = p.title;
          el.querySelector('.ha-price').textContent = money(p.price);
          wrap.appendChild(el);
        })
        .catch(function () {});
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Senaste sökningar                                                      */
  /* ---------------------------------------------------------------------- */
  var RKEY = 'haraka-recent-search';
  function renderRecent() {
    var ul = document.querySelector('[data-ha-recent]');
    var wrap = document.querySelector('[data-ha-recent-wrap]');
    if (!ul || !wrap) return;
    var list = store.get(RKEY, []);
    ul.innerHTML = '';
    list.forEach(function (q) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      a.textContent = q;
      li.appendChild(a);
      ul.appendChild(li);
    });
    wrap.hidden = list.length === 0;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('form[action*="/search"]')) return;
    var q = (f.querySelector('input[name="q"]') || {}).value;
    if (!q || !q.trim()) return;
    var list = store.get(RKEY, []).filter(function (x) { return x !== q.trim(); });
    list.unshift(q.trim());
    store.set(RKEY, list.slice(0, 6));
  }, true);

  /* ---------------------------------------------------------------------- */
  /* Medlemsruta vid första besöket (av som förval, slås på i Anpassa)      */
  /* ---------------------------------------------------------------------- */
  /* Slutfix 2026-09-26 punkt 7: rutan minns kunden.
     - haraka-medlem: satt när en anmälan gått igenom (här eller i någon annan
       medlemsruta på sidan) – rutan visas aldrig mer.
     - haraka-popup-stangd: tidpunkt när kunden stängde – rutan visas inte
       igen förrän efter data-dagar dagar.
     - Efter anmälan laddar Shopify om sidan med ?customer_posted=true#HaPopupForm:
       då öppnas rutan direkt med bekräftelsen (eller felet), annars syns den inte.
     - Öppnas inte ovanpå en annan ruta (varukorgslådan, snabbväljaren, menyn),
       den väntar tills den är stängd. */
  function initMemberPopup() {
    var pop = document.querySelector('[data-ha-popup]');
    var klarNagonstans = document.querySelector('[data-ha-medlem-klar]');
    if (klarNagonstans) store.set('haraka-medlem', Date.now());
    if (!pop) return;
    var card = pop.querySelector('.ha-popup__card');
    var form = pop.querySelector('form');
    var egenPost = form && form.id && window.location.hash === '#' + form.id;
    var svar = pop.querySelector('[data-ha-medlem-klar], [data-ha-mform-fel]');
    var tvinga = pop.hasAttribute('data-ha-popup-force');
    var dagar = parseInt(pop.dataset.dagar, 10) || 14;
    var forraFokus = null;

    function oppna() {
      forraFokus = document.activeElement;
      pop.hidden = false;
      lock(true);
      vackSkrappostskydd(pop);
      /* Fokus till rutan själv (skärmläsare läser rubriken); bara efter ett fel hamnar det i fältet.
         Fokus i fältet vid vanlig öppning fäller upp tangentbordet över rutan i mobilen. */
      var falt = pop.querySelector('[data-ha-mform-fel]') && pop.querySelector('input[type="email"]');
      try { (falt || card).focus({ preventScroll: true }); } catch (e) {}
    }
    function stang() {
      if (pop.hidden) return;
      pop.hidden = true;
      lock(false);
      if (!pop.querySelector('[data-ha-medlem-klar]')) store.set('haraka-popup-stangd', Date.now());
      if (forraFokus && forraFokus.focus) { try { forraFokus.focus({ preventScroll: true }); } catch (e) {} }
    }
    function annanRutaOppen() {
      return !!document.querySelector('cart-drawer.active, .nr-sv:not([hidden]), details[open] > .menu-drawer');
    }
    /* Shopifys kakruta: rutan väntar tills kunden svarat (QA 2026-10-08: båda syntes samtidigt
       vid första besöket och kakrutan täckte e-postfältet på mobilen). */
    function kakrutaOppen() {
      var b = document.getElementById('shopify-pc__banner');
      return !!b && b.getBoundingClientRect().height > 0 && getComputedStyle(b).visibility !== 'hidden';
    }

    pop.addEventListener('click', function (e) {
      if (e.target === pop || e.target.closest('[data-ha-popup-close]')) stang();
    });
    document.addEventListener('keydown', function (e) {
      if (pop.hidden) return;
      if (e.key === 'Escape') { stang(); return; }
      if (e.key !== 'Tab') return;
      /* Fokusfälla: Tab och Skift+Tab stannar i rutan så länge den är öppen. */
      var f = Array.prototype.filter.call(card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"])'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var forst = f[0], sist = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === forst || document.activeElement === card)) { e.preventDefault(); sist.focus(); }
      else if (!e.shiftKey && document.activeElement === sist) { e.preventDefault(); forst.focus(); }
      else if (!card.contains(document.activeElement)) { e.preventDefault(); forst.focus(); }
    });

    if (egenPost && svar) {
      oppna();
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('customer_posted');
        u.hash = '';
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
      return;
    }
    if (!tvinga) {
      if (store.get('haraka-medlem', 0)) return;
      var stangd = store.get('haraka-popup-stangd', 0);
      if (stangd && Date.now() - stangd < dagar * 864e5) return;
    }
    var delay = parseInt(pop.dataset.delay, 10) || 8000;
    /* Mobilfixarna 2026-10-08 (Mobilgranskning tema 22, problem 2): på mobil visas rutan aldrig
       på produktsidan (den täckte storleksvalet), och först vid halva sidan eller efter 30 s. */
    var mobil = window.matchMedia('(max-width: 749px)').matches;
    if (mobil && !tvinga && pop.dataset.mall === 'product') return;
    var forsok = 0, vantar = false, oppnad = false, start = Date.now();
    /* Rutan kommer att visas: hämta bilden under väntetiden i stället för när rutan
       öppnas (lazy gav en tom bildyta en stund). Bara för besökare som får rutan, och först
       efter load, så att den inte tar bandbredd från sidans första bild. */
    function hamtaBild() { setTimeout(function () { pop.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); }, 1500); }
    if (document.readyState === 'complete') hamtaBild(); else window.addEventListener('load', hamtaBild);
    function forsokOppna() {
      if (oppnad || vantar) return;
      if (kakrutaOppen() || (annanRutaOppen() && forsok++ < 20)) { vantar = true; setTimeout(function () { vantar = false; forsokOppna(); }, 3000); return; }
      oppnad = true;
      window.removeEventListener('scroll', vidScroll);
      oppna();
    }
    function vidScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= 0.5 && Date.now() - start >= delay) forsokOppna();
    }
    if (mobil) {
      window.addEventListener('scroll', vidScroll, { passive: true });
      setTimeout(forsokOppna, Math.max(delay, 30000));
    } else {
      setTimeout(forsokOppna, delay);
    }
  }

  /* ---------------------------------------------------------------------- */
  /* Kategorisidan: "Visa fler" och 1/2 kolumner på mobil                   */
  /* ---------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-ha-more]');
    if (more) {
      e.preventDefault();
      var url = more.getAttribute('href');
      more.classList.add('is-loading');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = document.querySelector('[data-ha-grid]');
          var newItems = doc.querySelectorAll('[data-ha-grid] > li');
          newItems.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          var newMore = doc.querySelector('[data-ha-more]');
          var pag = document.querySelector('[data-ha-pagination]');
          var newPag = doc.querySelector('[data-ha-pagination]');
          if (pag && newPag) pag.innerHTML = newPag.innerHTML;
          else if (pag && !newMore) pag.remove();
          syncWish();
          history.replaceState({}, '', url);
        })
        .finally(function () { more.classList.remove('is-loading'); });
      return;
    }
    var colBtn = e.target.closest('[data-ha-cols]');
    if (colBtn) {
      var g = document.querySelector('[data-ha-grid]');
      if (!g) return;
      g.setAttribute('data-cols-mobile', colBtn.getAttribute('data-ha-cols'));
      document.querySelectorAll('[data-ha-cols]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === colBtn ? 'true' : 'false');
      });
    }
  });

  /* ---------------------------------------------------------------------- */
  /* Lådor (filter, storleksguide): öppna/stäng via data-attribut           */
  /* ---------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-ha-drawer-open]');
    if (op) {
      e.preventDefault();
      var d = document.getElementById(op.getAttribute('data-ha-drawer-open'));
      if (!d) return;
      d.classList.add('is-open');
      var ov = document.querySelector('[data-ha-drawer-overlay]');
      ov && ov.classList.add('is-open');
      lock(true);
      return;
    }
    if (e.target.closest('[data-ha-drawer-close]')) {
      document.querySelectorAll('.ha-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
      var ov2 = document.querySelector('[data-ha-drawer-overlay]');
      ov2 && ov2.classList.remove('is-open');
      lock(false);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('.ha-drawer.is-open');
    if (!open.length) return;
    open.forEach(function (d) { d.classList.remove('is-open'); });
    var ov = document.querySelector('[data-ha-drawer-overlay]');
    ov && ov.classList.remove('is-open');
    lock(false);
  });

  /* ---------------------------------------------------------------------- */
  /* Produktsidan: fast köprad i mobilen tills den riktiga knappen syns     */
  /* ---------------------------------------------------------------------- */
  function initStickyBuy() {
    var submit = document.querySelector('.ha-t-product .product-form__submit');
    if (!submit || document.querySelector('.ha-stickybuy')) return;
    var title = (document.querySelector('.product__title h1') || {}).textContent || '';
    var priceEl = document.querySelector('.ha-t-product .price');
    var bar = document.createElement('div');
    bar.className = 'ha-stickybuy';
    bar.innerHTML = '<div class="ha-stickybuy__text"><span class="ha-stickybuy__title"></span><span class="ha-stickybuy__price"></span></div>' +
      '<button type="button" class="ha-btn ha-btn--primary">Lägg i varukorgen</button>';
    bar.querySelector('.ha-stickybuy__title').textContent = title.trim();
    function syncPrice() {
      // 2026-09-29: produktsidans pris ligger i [data-ha-pris] (sections/main-product)
      var p = document.querySelector('.ha-t-product [data-ha-pris]') || document.querySelector('.ha-t-product .price .price__sale .price-item--sale') || document.querySelector('.ha-t-product .price .price-item--regular');
      bar.querySelector('.ha-stickybuy__price').textContent = p ? p.textContent.trim() : '';
      var btn = bar.querySelector('button');
      btn.disabled = submit.disabled;
      btn.textContent = ((submit.querySelector('span') || submit).textContent || '').trim() || 'Lägg i varukorgen';
      // Visa vilken variant som köps, så att ingen lägger fel storlek i korgen
      var valt = [];
      document.querySelectorAll('.ha-t-product variant-selects fieldset input:checked').forEach(function (i) {
        if (i.value) valt.push(i.value.trim());
      });
      document.querySelectorAll('.ha-t-product variant-selects select').forEach(function (s) {
        if (s.value) valt.push(s.value.trim());
      });
      bar.querySelector('.ha-stickybuy__title').textContent = valt.length ? title.trim() + ' · ' + valt.join(', ') : title.trim();
    }
    document.body.appendChild(bar);
    syncPrice();
    // Knappen ska göra exakt det huvudknappen gör. Shopify har alltid en variant
    // förvald, så att i stället scrolla till storleksväljaren gjorde att kunden
    // tryckte och ingenting hamnade i korgen. Vilken variant det gäller står i
    // raden bredvid, och är varianten slut är knappen avstängd precis som uppe.
    bar.querySelector('button').addEventListener('click', function () {
      submit.click();
    });
    // 2026-09-29: raden visas först när huvudknappen har scrollats förbi uppåt (inte när sidan
    // laddas och knappen ännu ligger längre ned), och sidan får lika mycket luft längst ned
    // (klassen ha-stickybuy-pa, assets/ha-product.css) så att raden inte täcker något.
    // Knappens läge läses vid scroll (inte IntersectionObserver): ett snabbt hopp förbi knappen,
    // t.ex. via "Läs mer", ger ingen skärningsändring och raden skulle då aldrig visas.
    var visadNu = null;
    var vantar = false;
    function uppdatera() {
      vantar = false;
      var knapp = document.querySelector('.ha-t-product .product-form__submit') || submit;
      var visa = knapp.getBoundingClientRect().bottom < 0;
      if (visa === visadNu) return;
      visadNu = visa;
      bar.classList.toggle('is-visible', visa);
      document.body.classList.toggle('ha-stickybuy-pa', visa);
      syncPrice();
    }
    function schemalagg() {
      if (vantar) return;
      vantar = true;
      window.requestAnimationFrame(uppdatera);
    }
    window.addEventListener('scroll', schemalagg, { passive: true });
    window.addEventListener('resize', schemalagg);
    uppdatera();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncPrice, 50); });
    }
  }

  /* ---------------------------------------------------------------------- */
  /* Start                                                                  */
  /* ---------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------- */
  /* Kundformulären och Shopifys skräppostskydd                             */
  /*                                                                        */
  /* Shopify lägger ett osynligt skydd på alla kundformulär: medlem,        */
  /* kontakt och returformuläret. Skyddets fil laddas först när kunden rör  */
  /* ett fält, och fram till att den är på plats avbryter Shopify VARJE     */
  /* inskickning i tysthet: knappen ser död ut.                             */
  /* Därför två saker: vi väcker skyddet redan när panelen öppnas, och om   */
  /* kunden hinner trycka före väntar vi in det och skickar då.             */
  /* ---------------------------------------------------------------------- */
  function vackSkrappostskydd(scope) {
    (scope || document).querySelectorAll('.ha-member-form input[type="email"]').forEach(function (inp) {
      inp.dispatchEvent(new Event('focusin', { bubbles: true }));
    });
  }

  function statusrad(form) {
    var p = form.querySelector('.ha-member-form__status');
    if (!p) {
      p = document.createElement('p');
      p.className = 'ha-member-form__status';
      p.setAttribute('role', 'status');
      form.appendChild(p);
    }
    return p;
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    // Gäller bara de Shopify-formulär som skyddet tar hand om: medlem (customer),
    // kontakt och retur (contact). Köpformuläret (product) avbryts också av
    // product-form.js, men det skickar själv med fetch. Fångades det här låstes
    // köpknappen med "Skickar …" i 12 s, spinnern i knappen försvann och en
    // felrad visades trots att varan låg i varukorgen (rättat 2026-09-26).
    var typ = f.querySelector && f.querySelector('input[name="form_type"]');
    if (!typ || (typ.value !== 'customer' && typ.value !== 'contact')) return;
    if (!e.defaultPrevented) return; // gick igenom, inget att vänta på
    // Är skyddet redan påkopplat är det skyddet självt som håller inne
    // inskickningen medan det kontrollerar. Då ska vi inte lägga oss i.
    if (f.dataset.hcaptchaBound === 'true' || f.dataset.recaptchaBound === 'true') return;
    if (f.dataset.haVantar === '1') return;
    f.dataset.haVantar = '1';

    var btn = f.querySelector('button[type="submit"]');
    var btnText = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Skickar …';
    }
    var p = statusrad(f);
    p.classList.remove('is-fel');
    p.textContent = '';

    var start = Date.now();
    var iv = setInterval(function () {
      var klart = f.dataset.hcaptchaBound === 'true' || f.dataset.recaptchaBound === 'true';
      if (!klart && Date.now() - start < 12000) return;
      clearInterval(iv);
      f.dataset.haVantar = '0';
      if (btn) {
        btn.disabled = false;
        btn.textContent = btnText;
      }
      if (klart) {
        if (f.requestSubmit) f.requestSubmit();
        else f.submit();
      } else {
        p.classList.add('is-fel');
        p.textContent = 'Det gick inte att skicka just nu. Stänger din webbläsare av skript kan du i stället mejla info@haraka.se, så lägger vi till dig.';
      }
    }, 250);
  });

  /* ---------------------------------------------------------------------- */
  /* Efter medlemsanmälan: öppna panelen så att kunden ser bekräftelsen      */
  /* ---------------------------------------------------------------------- */
  function initAccountReturn() {
    // Öppna panelen både när anmälan gick igenom och när servern gav ett fel,
    // annars står svaret osynligt i en dold panel.
    var postat = /[?&]customer_posted=/.test(window.location.search);
    var svar = document.querySelector('[data-panel="account"] .ha-member-form__ok, [data-panel="account"] .ha-member-form__err');
    if (!postat && !svar) return;
    var head = document.querySelector('ha-header');
    if (!head || typeof head.open !== 'function') return;
    head.open('account');
    var tab = head.querySelector('[data-ha-tab="member"]');
    if (tab) tab.click();
    // Ta bort parametern, annars öppnas panelen igen vid omladdning
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('customer_posted');
      window.history.replaceState({}, '', u.toString());
    } catch (e) {}
  }

  /* ---------------------------------------------------------------------- */
  /* Medlemsrabatten: lägg koden i kassan direkt när någon blivit medlem     */
  /*                                                                        */
  /* /discount/KODEN lägger koden i kundens session hos Shopify, och sedan  */
  /* dras rabatten av i kassan utan att kunden skriver något. Vi hämtar den */
  /* adressen i bakgrunden och landar på /cart.js, som är några hundra byte */
  /* i stället för en hel sida. Går det inte fram står knappen kvar och gör */
  /* samma sak med ett klick.                                               */
  /* ---------------------------------------------------------------------- */
  function initMedlemsrabatt() {
    document.querySelectorAll('[data-ha-rabatt]').forEach(function (box) {
      if (box.dataset.haRabattKlar === '1') return;
      var kod = box.dataset.haRabatt;
      if (!kod) return;
      box.dataset.haRabattKlar = '1';
      fetch('/discount/' + encodeURIComponent(kod) + '?redirect=/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          var fore = box.querySelector('[data-ha-rabatt-fore]');
          var efter = box.querySelector('[data-ha-rabatt-efter]');
          var lank = box.querySelector('[data-ha-rabatt-lank]');
          if (fore) fore.hidden = true;
          if (efter) efter.hidden = false;
          if (lank) lank.hidden = true;
        })
        .catch(function () {
          /* Knappen ligger kvar och gör jobbet manuellt. */
        });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Fyll på till fri frakt: knappen i varukorgen (snippets/ha-fillup)       */
  /*                                                                        */
  /* Lägger i varan med /cart/add.js och ber om varukorgens sektioner i     */
  /* samma svar, precis som temats egen köpknapp, så att lådan ritas om     */
  /* med ny summa och ny fraktrad. Finns ingen låda går vi till /cart.      */
  /* ---------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ha-fill-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var drawer = document.querySelector('cart-drawer');
    var box = btn.closest('.ha-fillup');
    var err = box && box.querySelector('[data-ha-fill-err]');
    var text = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Lägger till …';
    if (err) err.hidden = true;
    var body = { items: [{ id: Number(btn.dataset.haFillAdd), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'fel');
        /* På varukorgssidan ritas sidan själv om, annars visar den gamla summan bakom lådan (prov 2026-09-29). */
        if (window.location.pathname === '/cart') {
          window.location.reload();
          return;
        }
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty'); /* som Dawns product-form.js */
          drawer.renderContents(res);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ha-fillup', cartData: res });
          }
        } else {
          window.location = '/cart';
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = text;
        if (err) err.hidden = false;
      });
  });

  /* Slutfix 2026-09-26 punkt 8: "2 varor" bredvid rubriken på varukorgssidan följer med
     när antalet ändras. Dawns cart.js skickar korgens nya läge med cartUpdate. */
  function initVarukorgAntal() {
    var el = document.querySelector('[data-ha-vk-antal]');
    if (!el || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      var n = e && e.cartData && typeof e.cartData.item_count === 'number' ? e.cartData.item_count : null;
      if (n === null) return;
      el.textContent = n > 0 ? n + (n === 1 ? ' vara' : ' varor') : '';
    });
  }

  /* Slutfix 2026-09-26 punkt 12: den markerade underkategorin rullas fram i den svepbara
     raden, så att kunden ser var hen är även när pillret ligger utanför skärmen. */
  function initAktivtPiller() {
    document.querySelectorAll('.ha-chips--scroll .ha-chip.is-active').forEach(function (a) {
      var rad = a.parentElement;
      if (!rad || rad.scrollWidth <= rad.clientWidth) return;
      var mal = a.offsetLeft - (rad.clientWidth - a.offsetWidth) / 2;
      rad.scrollLeft = Math.max(0, mal);
    });
  }

  function init() {
    initAktivtPiller();
    initTopbar();
    initCarousels();
    initHoverSwap();
    initMemberPopup();
    initVarukorgAntal();
    initStickyBuy();
    initAccountReturn();
    initMedlemsrabatt();
    initKortbilder();
    syncWish();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    initCarousels(e.target);
    initHoverSwap();
    syncWish();
  });

  window.Haraka = { syncWish: syncWish, initCarousels: initCarousels };
})();

/* Shopifys kakruta länkar till /sv/policies/privacy-policy, som ger 404 (svenska ligger i roten
   på haraka.se). Tills länken rättas i butikens inställningar skrivs /sv/policies/ om till
   /policies/ när kunden klickar (Tema 22 Fixar 2026-10-11). */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href*="/sv/policies/"]');
  if (a) a.href = a.getAttribute('href').replace('/sv/policies/', '/policies/');
}, true);
